import { useEffect, useState } from "react";

export default function ChecklistExam({
  name,
  groupId,
  selectedJury,
  setSelectedJury,
}) {
  const checkboxes = [1, 2, 3, 4];

  return (
    <>
      <label
        htmlFor="group"
        className="text-md border border-black px-2 py-1 col-span-4 my-1"
      >
        {name}
      </label>
      {checkboxes.map((checkbox, index) => (
        <Box
          groupId={groupId}
          selectedJury={selectedJury}
          setSelectedJury={setSelectedJury}
          checkbox={checkbox}
          key={checkbox}
          isChecked={
            selectedJury.some(
              (item) =>
                parseInt(item.juryId) === index + 1 && groupId === item.groupId
            )
              ? true
              : false
          }
        />
      ))}
    </>
  );
}

function Box({ groupId, selectedJury, setSelectedJury, checkbox, isChecked }) {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  function handelChange(juryId) {
    if (!checked) {
      setSelectedJury([...selectedJury, { groupId, juryId }]);
    } else {
      setSelectedJury(
        selectedJury.filter(
          (box) => !(box.groupId === groupId && box.juryId === juryId)
        )
      );
    }
    setChecked(!checked);
  }
  return (
    <>
      <label htmlFor={checkbox} className="sr-only">
        {checkbox}
      </label>
      <input
        id={checkbox}
        key={checkbox}
        type="checkbox"
        name={checkbox}
        color="green"
        className="w-10 h-10 ml-2 my-1 accent-primary-validate"
        onChange={(e) => handelChange(parseInt(e.target.id))}
        checked={checked}
      />
    </>
  );
}
